import React from "react";
import { TitleSection, BreakLine } from "./UserSection";

import "./UserPolls.scss";

const UserPolls = () => (
  <div id="user-polls">
    <TitleSection title="Participación en encuestas" />
    <BreakLine />
  </div>
);

export default UserPolls;
